(function () {
  'use strict';

  function selectedOptionValues(picker) {
    var out = {};
    try {
      picker.querySelectorAll('input[name^="option"]').forEach(function (inp) {
        if (inp.value) out[inp.name] = inp.value;
      });
    } catch (_) {}
    return out;
  }

  function resolveVariant(product, clickedName, clickedValue, sel) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return null;

    var opts = {};
    Object.keys(sel || {}).forEach(function (k) { opts[k] = sel[k]; });
    if (clickedName) opts[clickedName] = clickedValue;
    var names = Object.keys(opts);

    var exact = variants.find(function (v) {
      return names.every(function (n) {
        var i = parseInt(n.replace('option', ''), 10) - 1;
        return String((v.options || [])[i]) === String(opts[n]);
      });
    });
    if (exact) return exact;

    return (
      variants.find(function (v) {
        return v.available && (v.options || []).some(function (o) { return String(o) === String(clickedValue); });
      }) ||
      variants.find(function (v) {
        return (v.options || []).some(function (o) { return String(o) === String(clickedValue); });
      }) ||
      null
    );
  }

  function variantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id != null) return variant.featured_media.id;
    if (variant.featured_image && variant.featured_image.id != null) return variant.featured_image.id;
    return null;
  }

  // Product data source — portable across stores: window.ShopifyProduct (some sections set it)
  // OR the #product-data JSON the AGB section always emits OR window.AGB_BOOT.productJson.
  function getProduct() {
    if (window.ShopifyProduct && window.ShopifyProduct.variants) return window.ShopifyProduct;
    try {
      var el = document.getElementById('product-data');
      if (el) { var p = JSON.parse(el.textContent || '{}'); if (p && p.variants) return p; }
    } catch (_) {}
    var b = window.AGB_BOOT && window.AGB_BOOT.productJson;
    if (b && b.variants) return b;
    return null;
  }

  function numericTail(id) { return String(id).replace(/^.*\//, ''); }

  function galleryIsVisible() {
    var g = document.querySelector('.product-gallery');
    return !!(g && g.offsetParent !== null);
  }

  function findThumbnail(mediaId) {
    if (mediaId == null) return null;
    var direct = document.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
    if (direct) return direct;
    var want = numericTail(mediaId);
    var all = document.querySelectorAll('.product-gallery__thumbnail[data-media-id]');
    for (var i = 0; i < all.length; i++) {
      if (numericTail(all[i].getAttribute('data-media-id')) === want) return all[i];
    }
    return null;
  }

  function showMedia(mediaId) {
    if (mediaId == null || !galleryIsVisible()) return;
    var want = numericTail(mediaId);

    var carousel = document.querySelector('.product-gallery__carousel');
    if (carousel && typeof carousel.select === 'function' && carousel.cells) {
      var cells = carousel.cells;
      for (var i = 0; i < cells.length; i++) {
        var id = cells[i] && cells[i].getAttribute && cells[i].getAttribute('data-media-id');
        if (id && numericTail(id) === want) {
          try {
            if (carousel.selectedIndex === i) return;
            carousel.select(i, { instant: true });
            return;
          } catch (_) { break; }
        }
      }
    }

    var thumb = findThumbnail(mediaId);
    if (thumb && thumb.getAttribute('aria-current') !== 'true') thumb.click();
  }

  var generation = 0;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-option-value]');
    if (!swatch) return;
    var picker = swatch.closest('variant-picker');
    if (!picker) return;

    var input = swatch.querySelector('input') || swatch.previousElementSibling;
    var clickedName = input && input.name;
    var clickedValue =
      swatch.getAttribute('value') ||
      (input && input.value) ||
      (swatch.textContent || '').trim();
    if (!clickedValue) return;

    var product = getProduct();
    if (!product) return;

    var myGen = ++generation;

    [0, 90, 220, 450].forEach(function (delay) {
      setTimeout(function () {
        if (myGen !== generation) return;
        try {
          var variant = resolveVariant(product, clickedName, clickedValue, selectedOptionValues(picker));
          showMedia(variantMediaId(variant));
        } catch (_) {}
      }, delay);
    });
  }, true);
})();